import { Ability } from "@casl/ability";

import { AbilityRulesStore } from "../../../../legacy/stores/abilityRulesStore";
import { globalStore } from "../../../../stores/global.store";

import type { AbacPermission, AbacPermissions, BonusXAbility } from "../types/abac.type";
import type { GuardCheckResult } from "../types/guard.type";
import type { IAbacGuardService } from "./abac.guard.interface";
import { authGuardService } from "./auth.guard.service";

export class AbacGuardService implements IAbacGuardService {
  private static instance: AbacGuardService;

  private constructor() {}

  static getInstance(): AbacGuardService {
    if (!AbacGuardService.instance) {
      AbacGuardService.instance = new AbacGuardService();
    }

    return AbacGuardService.instance;
  }

  setAbility(rawAbilities: object[]): void {
    globalStore.set(AbilityRulesStore, rawAbilities);
  }

  getAbility(): BonusXAbility {
    const rules = globalStore.get(AbilityRulesStore);
    const ability = new Ability(rules) as BonusXAbility;
    return ability;
  }

  can(action: AbacPermission["can"], model: AbacPermission["model"]): boolean {
    const result = this.getAbility().can(action, model);
    return result;
  }

  canAll(permissions: AbacPermissions): boolean {
    const permissionArray = Array.isArray(permissions) ? permissions : [permissions];
    const result = permissionArray.every(this.checkPermission.bind(this));
    return result;
  }

  canAny(permissions: AbacPermissions): boolean {
    const permissionArray = Array.isArray(permissions) ? permissions : [permissions];
    const result = permissionArray.some(this.checkPermission.bind(this));
    return result;
  }

  private checkPermission(permission: AbacPermission): boolean {
    const result = this.can(permission.can, permission.model);
    return result;
  }

  check(permissions: AbacPermissions, options: { redirectTo?: string; requireAuth?: boolean } = {}): GuardCheckResult {
    const { redirectTo = "/welcome", requireAuth = true } = options;

    if (requireAuth && !authGuardService.isAuthenticated()) {
      return {
        allowed: false,
        redirectTo,
      };
    }

    const hasPermission = this.canAll(permissions);

    return {
      allowed: hasPermission,
      redirectTo: hasPermission ? undefined : redirectTo,
    };
  }
}

export const abacGuardService = AbacGuardService.getInstance();
